module.exports = __webpack_public_path__ + "img/teaching_6.2d948299.png";